<template>
  <div class="card-content">
    <v-list-item @click="handleRowClick(item,index)">
      <v-list-item-avatar
        style="min-width: 94.11px;"
        size="large"
        rounded
        color="#a8a8a8"
      >
        <v-list-item-content class="time-span">
          <div>{{ formatTime(item.courseStartTime) }}</div>
          <div>~</div>
          <div>{{ formatTime(item.courseEndTime) }}</div>
        </v-list-item-content>
      </v-list-item-avatar>
      <v-row>
        <v-col
          :cols="12"
          :md="status?3:12"
          :lg="status?3:12"
        >
          <div> Course: {{ `${item.course.courseCode} ${item.course.courseName}` }} </div>
          <div v-if="showCoach">
            Coach: {{ item.assignedCoach.fullName }}
          </div>
          <div> Student: {{ item.userRecord.fullName }} </div>
          <div> Center: {{ item.center.description }} </div>
        </v-col>
        <v-col v-if="status">
          <div> Transfer Status: <span style="color:#1976D2">{{ status }} </span></div>
          <div> To Coach: {{ toCoach }} </div>
        </v-col>
      </v-row>
    </v-list-item>
  </div>
</template>
<script setup>
import { computed, ref, toRefs, onMounted, watch } from 'vue'
import { formatTime } from '@/utils/helper'

const props = defineProps({
  item: {
    type: Object,
    default: () => ({ bookingTransfers: [] }),
  },
  index: {
    type: Number,
    default: 0,
  },
  showCoach: {
    type: Boolean,
    default: false },
})
const { item, index, showCoach } = toRefs(props)

function getTransfer() {
  if (item.value.bookingTransfers && item.value.bookingTransfers.length > 0) {
    const pending = item.value.bookingTransfers.filter(transfer => transfer.transferStatusID === 1)
    console.log('pending', pending)
    if (pending.length > 0) {
      return pending[0]
    }
  }

  return null
}

const toCoach = computed(() => {
  const transfer = getTransfer()
  if (transfer) {
    return transfer.toCoach.fullName
  }

  return ''
})

const status = computed(() => {
  const transfer = getTransfer()
  if (transfer) {
    return transfer.transferStatus.description
  }

  return ''
})

// onMounted(() => {
//   console.log('getStatus item', item.value)
//   status.value = getStatus()
//   console.log(' status.value', status.value)
// })

const emit = defineEmits(['click'])

function handleRowClick(item, index) {
  console.log('handleRowClick', item, index)
  emit('click', item, index)
}
</script>
<style scoped>

.time-span {
  color: white
}
</style>
